import React, { useEffect, useRef, useState } from "react";
import { Alert, Spin, Typography } from "antd";
import { Html5Qrcode } from "html5-qrcode";

const { Text } = Typography;

const BarcodeScanner = ({ onScan, onError }) => {
  const scannerIdRef = useRef(`qr-reader-${Math.random().toString(36).slice(2)}`);
  const html5QrCodeRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const startScanner = async () => {
      try {
        setLoading(true);

        const html5QrCode = new Html5Qrcode(scannerIdRef.current);
        html5QrCodeRef.current = html5QrCode;

        await html5QrCode.start(
          { facingMode: "environment" },
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            aspectRatio: 1.7778,
          },
          (decodedText) => {
            if (!mounted) return;
            onScan?.(decodedText);
          },
          () => {
            // ignore scan errors frame-by-frame
          }
        );

        if (mounted) {
          setIsScanning(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("QR scanner start error:", error);
        onError?.(error);
        if (mounted) {
          setIsScanning(false);
          setLoading(false);
        }
      }
    };

    startScanner();

    return () => {
      mounted = false;

      const stopScanner = async () => {
        try {
          if (html5QrCodeRef.current?.isScanning) {
            await html5QrCodeRef.current.stop();
          }
          await html5QrCodeRef.current?.clear();
        } catch (error) {
          console.error("QR scanner stop error:", error);
        }
      };

      stopScanner();
    };
  }, [onScan, onError]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: 400,
        borderRadius: 12,
        overflow: "hidden",
        background: "#000",
      }}
    >
      <div
        id={scannerIdRef.current}
        style={{
          width: "100%",
          minHeight: 400,
        }}
      />

      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0,0,0,0.55)",
            zIndex: 10,
          }}
        >
          <Spin size="large" />
          <Text style={{ color: "#fff", marginTop: 12 }}>
            Starting camera...
          </Text>
        </div>
      )}

      {!isScanning && !loading && (
        <div
          style={{
            position: "absolute",
            bottom: 16,
            left: 16,
            right: 16,
            zIndex: 12,
          }}
        >
          <Alert
            message="Scanner stopped or unavailable"
            description="Please check camera permission and try again."
            type="warning"
            showIcon
          />
        </div>
      )}
    </div>
  );
};

export default BarcodeScanner;